<!-- @format -->

<ng-container *transloco="let t">
  @if (cart) {
    <app-cart-accordions
      [cart]="cart"
      [isEditable]="true"
      [checkEnrolments$]="checkEnrolments$"
      (hasValidEnrolments)="hasValidEnrolments.emit()">
    </app-cart-accordions>
    @if ((isStudyVoucherPaymentEnabled$ | async) && cartHasNoFreeItems) {
      <fudis-heading [class]="'fudis-mb-xs fudis-mt-md'" [level]="3" [variant]="'md'">{{
        t("OPEN_UNIVERSITY_CART.PAYMENT_TYPE.PAYMENT_METHODS")
      }}</fudis-heading>
      <div class="payments-options fudis-mb-sm">
        <sis-selection-box
          [translatedTitle]="t('OPEN_UNIVERSITY_CART.PAYMENT_TYPE.MONETARY_PAYMENT')"
          [control]="paymentTypeControl"
          [value]="'MONETARY_PAYMENT'"
          [type]="'radio'"
          [name]="'paymentType'"
          [id]="'monetary-payment'">
          <fudis-body-text [variant]="'md-regular'">{{
            t("OPEN_UNIVERSITY_CART.PAYMENT_TYPE.MONETARY_PAYMENT_DESCRIPTION")
          }}</fudis-body-text>
        </sis-selection-box>
        <sis-selection-box
          [translatedTitle]="t('OPEN_UNIVERSITY_CART.PAYMENT_TYPE.STUDY_VOUCHER_PAYMENT')"
          [control]="paymentTypeControl"
          [value]="'STUDY_VOUCHER_PAYMENT'"
          [type]="'radio'"
          [name]="'paymentType'"
          [id]="'study-voucher-payment'">
          <fudis-body-text [variant]="'md-regular'">
            {{ t("OPEN_UNIVERSITY_CART.PAYMENT_TYPE.STUDY_VOUCHER_PAYMENT_DESCRIPTION") }}
            <a
              fudisLink
              [title]="t('OPEN_UNIVERSITY_CART.PAYMENT_TYPE.STUDY_VOUCHER_PAYMENT_LINK_TEXT')"
              [href]="t('OPEN_UNIVERSITY_CART.PAYMENT_TYPE.STUDY_VOUCHER_PAYMENT_LINK_URL')"
              [external]="true"></a>
          </fudis-body-text>
        </sis-selection-box>
      </div>

      @if (paymentTypeControl.value === "STUDY_VOUCHER_PAYMENT") {
        <fudis-notification [class]="'fudis-mb-sm'" [variant]="'warning'">
          <fudis-body-text>
            {{ t("OPEN_UNIVERSITY_CART.PAYMENT_TYPE.STUDY_VOUCHER_NOTIFICATION") }}
          </fudis-body-text>
        </fudis-notification>
      }
    }
    <div class="row price-and-discount">
      <div class="col-sm-7">
        <app-cart-price [cart]="cart" [paymentType]="paymentTypeControl.value" [totalCredits]="totalCredits"></app-cart-price>
      </div>
      <div class="col-sm-5"> </div>
    </div>
  }
</ng-container>
